import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

/** @deprecated Exporting the component so that it can be used in other files. */
export default RadioButtonUncheckedIcon;
